import type { ManualChapter } from '../types';
import { orderedChapters } from '../manualRules';
import { chapter as start } from './start';
import { chapter as planner } from './planner';
import { chapter as ftlLead } from './ftlLead';
import { chapter as trade } from './trade';
import { chapter as cs } from './cs';
import { chapter as administration } from './administration';
import { chapter as admin } from './admin';

/**
 * Rozdziały instrukcji obsługi (28.10.2026, S-28.10-02) — jeden plik na
 * rozdział, nazwany kluczem rozdziału. Skrypt PDF czyta te same pliki.
 */
export const MANUAL_CHAPTERS: readonly ManualChapter[] = orderedChapters([
  start,
  planner,
  ftlLead,
  trade,
  cs,
  administration,
  admin,
]);
